// Dubai - routine AC cleaning (general service).
const content = {
    slug: 'ac-cleaning',
    title: (c) => `AC Cleaning Dubai from ${c.money(c.tables.general[0].wall)} | Split & Ducted Units`,
    description: (c) =>
        `Routine AC cleaning in Dubai: ${c.money(c.tables.general[0].wall)} for a split unit, ${c.money(c.tables.general[0].ducted)} for ducted. Filter, coil, blower and drain checked in one visit.`,
    eyebrow: 'Dubai · AC cleaning',
    h1: 'AC Cleaning in Dubai',
    lead: (c) =>
        `The three-to-four-monthly clean that keeps a Dubai AC cooling properly through the dust and the heat. One split unit costs ${c.money(c.tables.general[0].wall)}; three units cost ${c.money(c.tables.general[2].wall)} in total.`,
    image: 'blog/living/dirty-aircon-filters.jpg',
    imageAlt: 'Dust-clogged AC filter removed during a routine cleaning in Dubai',
    facts: ['Every 3-4 months', 'Split and ducted units', 'About 45 minutes per unit'],
    priceTitle: 'AC cleaning prices',
    priceIntro: 'The price per unit drops as you add units, so book every unit in the home on one visit.',
    panel: { type: 'servicing', services: ['general'], defaultMount: 'Ducted' },
    sections: [
        {
            // Target of the hero card's Service Details link
            id: 'included',
            title: 'What a routine AC cleaning covers',
            items: [
                'Filter and return-air grille washed and dried.',
                'Indoor coil surface brushed and rinsed where reachable.',
                'Blower wheel wiped down and checked for wobble or noise.',
                'Drain tray cleaned and condensate line flushed with water.',
                'Outdoor unit fins brushed off (split systems with their own condenser).',
                'Supply-air temperature and airflow checked before the technician leaves.',
            ],
            columns: 2,
        },
        {
            title: 'Cleaning or chemical wash?',
            tone: 'muted',
            cards: [
                { title: 'Choose cleaning when', body: 'The unit cools well and you are keeping it that way. It is maintenance, not a fix - the right job every three to four months.' },
                { title: 'Choose a coil wash when', body: 'There is a smell, weak airflow or black specks at the diffusers even after cleaning. The dirt is baked onto the coil and needs chemicals.' },
                { title: 'Not sure?', body: 'Book a cleaning. The technician tells you on the day if the coil needs a chemical wash, and you decide before any extra work.' },
            ],
        },
        {
            title: 'Between visits: what you can do yourself',
            paragraphs: [
                'Wash the filter every month from May to October, and after every dust storm. On a concealed ducted unit it sits behind the return-air grille - usually the large grille in the ceiling of the corridor or living room. Rinse it under the tap, let it dry fully, and put it back.',
                'Keep balcony doors shut while the AC runs; open doors pull in hot, dusty air and the coil pays for it. And set the thermostat to 24°C or above - each degree lower adds noticeably to your DEWA bill in summer.',
            ],
        },
    ],
    faqs: [
        {
            question: 'How much is AC cleaning in Dubai?',
            answer: (c) => `${c.money(c.tables.general[0].wall)} for one split unit, ${c.money(c.tables.general[1].wall)} for two and ${c.money(c.tables.general[2].wall)} for three. Concealed ducted units start at ${c.money(c.tables.general[0].ducted)}. Travel is included.`,
        },
        {
            question: 'How often should I clean my AC in Dubai?',
            answer: 'Every three to four months for a professional cleaning, with monthly filter washes in summer. Homes near construction or with pets may need cleaning every two to three months.',
        },
        {
            question: 'Do I need to be home during the cleaning?',
            answer: 'Someone needs to let the technician in and show them the units and the ceiling access panel. You do not need to stay in the room.',
        },
        {
            question: 'Will the technician need to move furniture?',
            answer: 'Only to reach the unit or the access panel safely. Clear the area under wall units and access panels before the visit to save time.',
        },
        {
            question: 'Can you clean window AC units?',
            answer: 'Yes. Book the split option - a window unit takes about the same time - and mention it in the notes so the technician comes prepared.',
        },
    ],
    schema: {
        name: 'AC Cleaning in Dubai',
        serviceType: 'Air conditioner cleaning',
        offers: (c) => [
            { name: 'AC cleaning, 1 split unit', price: c.tables.general[0].wall },
            { name: 'AC cleaning, 2 split units', price: c.tables.general[1].wall },
            { name: 'AC cleaning, 3 split units', price: c.tables.general[2].wall },
            { name: 'AC cleaning, 1 ducted unit', price: c.tables.general[0].ducted },
        ],
    },
}

export default content
